
import {
  GET_COLLECTION_NAME_VERIFY,
  GET_COLLECTION_NAME_VERIFY_FAIL,
  GET_COLLECTION_NAME_VERIFY_SUCCESS,
  GET_COLLECTION_BYTECODE,
  GET_COLLECTION_BYTECODE_FAIL,
  GET_COLLECTION_BYTECODE_SUCCESS,
  GET_COLLECTIONS,
  GET_COLLECTIONS2,
  GET_COLLECTIONS_FAIL,
  GET_COLLECTIONS_FAIL2,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_SUCCESS2,
  POST_COLLECTION,
  POST_COLLECTION_FAIL,
  POST_COLLECTION_SUCCESS,
  GET_COLLECTION,
  GET_COLLECTION_BY_ADDRESS,
  GET_COLLECTION_FAIL,
  GET_COLLECTION_SUCCESS,
  PUT_COLLECTION,
  PUT_COLLECTION_FAIL,
  PUT_COLLECTION_SUCCESS,
  DELETE_COLLECTION,
  DELETE_COLLECTION_FAIL,
  DELETE_COLLECTION_SUCCESS,
  POST_NEW_COLLECTION_FAIL,
  POST_NEW_COLLECTION_SUCCESS,
  GET_NEW_COLLECTIONS_BY_EMAIL_START,
  GET_NEW_COLLECTIONS_BY_EMAIL_SUCCESS,
  GET_NEW_COLLECTIONS_BY_EMAIL_FAIL,
  PUT_NEW_COLLECTION_START,
  PUT_NEW_COLLECTION_FAIL,
  PUT_NEW_COLLECTION_SUCCESS,
  DELETE_NEW_COLLECTION_FAIL,
  DELETE_NEW_COLLECTION_SUCCESS,
  DELETE_NEW_COLLECTION_START,
  PUT_NEW_COLLECTION_BY_ID_START,
  PUT_NEW_COLLECTION_BY_ID_FAIL,
  PUT_NEW_COLLECTION_BY_ID_SUCCESS,
  GET_NEW_COLLECTION_BY_ID_START,
  GET_NEW_COLLECTION_BY_ID_FAIL,
  GET_NEW_COLLECTION_BY_ID_SUCCESS,
  GET_ALL_NEW_COLLECTION_SUCCESS,
  GET_ALL_NEW_COLLECTION_START,
  GET_ALL_NEW_COLLECTION_FAIL,
  POST_NEW_COLLECTION,
  GET_ALL_NEW_COLLECTION_WITH_FILTER_START,
  GET_ALL_NEW_COLLECTION_WITH_FILTER_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  collections: [],
  totalCollections: 0,
  collection: {},
  collectionItems: 0,
  floorPrice: 0,
  latestPrice: 0,
  collectionByEmail: [],
  AllNewCollectionsWithFilter: [],
};

const Collections = (state = INIT_STATE, action) => {
  switch (action.type) {
    /* Get Collection Name Verify */
    case GET_COLLECTION_NAME_VERIFY:
    case GET_COLLECTION_BYTECODE:

      return {
        ...state,
        loading: true,
      };

    case GET_COLLECTION_NAME_VERIFY_SUCCESS:
    case GET_COLLECTION_BYTECODE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case GET_COLLECTION_NAME_VERIFY_FAIL:
    case GET_COLLECTION_BYTECODE_FAIL:
      return {
        ...state,
        loading: false,
      };
    /* Get Collection Name Verify */

    /* Get Collections */
    case GET_COLLECTIONS:
    case GET_COLLECTIONS2:
    case GET_NEW_COLLECTIONS_BY_EMAIL_START:
    case GET_ALL_NEW_COLLECTION_START:
      return {
        ...state,
        loading: true,
      };

    case GET_COLLECTIONS_SUCCESS:
    case GET_NEW_COLLECTIONS_BY_EMAIL_SUCCESS:
      return {
        ...state,
        collectionByEmail: action.payload.data || [],
        // totalCollections: action.payload.totalCount || 0,
        loading: false,
        error: "",
      };

    case GET_ALL_NEW_COLLECTION_SUCCESS:

      return {
        ...state,
        allNewCollection: action.payload.data || [],
        // totalCollections: action.payload.totalCount || 0,
        loading: false,
        error: "",
      };

    case GET_COLLECTIONS_FAIL:
    case GET_COLLECTIONS_FAIL2:
    case GET_NEW_COLLECTIONS_BY_EMAIL_FAIL:
    case GET_ALL_NEW_COLLECTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    /* Get Collections END */

    /* Add Collection */
    case POST_COLLECTION:
    case POST_NEW_COLLECTION:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case POST_COLLECTION_FAIL:
    case POST_NEW_COLLECTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case POST_COLLECTION_SUCCESS:
    case POST_NEW_COLLECTION_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
      };
    /* Add Collection END */

    /* Get Collection */
    case GET_COLLECTION:
    case GET_COLLECTION_BY_ADDRESS:
    case GET_NEW_COLLECTION_BY_ID_START:
      return {
        ...state,
        error: "",
        loading: true,
        collection: {},
      };

    case GET_COLLECTION_FAIL:
    case GET_NEW_COLLECTION_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        collection: {},
      };

    case GET_COLLECTION_SUCCESS:
    case GET_NEW_COLLECTION_BY_ID_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
        collection: action.payload.data,
        collectionItems: action.payload.collectionItems,
        floorPrice: action.payload.floorPrice,
        latestPrice: action.payload.latestPrice,
      };
    /* Add Collection END */

    /* Update Collection */
    case PUT_COLLECTION:
    case PUT_NEW_COLLECTION_START:
    case PUT_NEW_COLLECTION_BY_ID_START:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case PUT_COLLECTION_FAIL:
    case PUT_NEW_COLLECTION_FAIL:
    case PUT_NEW_COLLECTION_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case PUT_COLLECTION_SUCCESS:
    case PUT_NEW_COLLECTION_SUCCESS:
    case PUT_NEW_COLLECTION_BY_ID_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
      };
    /* Update Collection END */

    /* Delete Collection */
    case DELETE_COLLECTION:
    case DELETE_NEW_COLLECTION_START:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case DELETE_COLLECTION_FAIL:
    case DELETE_NEW_COLLECTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case DELETE_COLLECTION_SUCCESS:
    case DELETE_NEW_COLLECTION_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
      };
    /* Delete Collection END */
    case GET_ALL_NEW_COLLECTION_WITH_FILTER_START:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_NEW_COLLECTION_WITH_FILTER_SUCCESS:
      return {
        ...state,
        error: "",
        loading: false,
        AllNewCollectionsWithFilter: action.payload || []
      };

    default:
      return state;
  }
};

export default Collections;